module.exports = __webpack_public_path__ + "img/pro_s2_icon6.3d63a3bd.png";